import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PaperMachines from './pages/PaperMachines';
import IndustrialMachines from './pages/IndustrialMachines';
import Navbar from './components/Navbar';
import Categories from './pages/Categories';
import CategoryMachines from './pages/CategoryMachines';
import MachineDetail from './pages/MachineDetail';
import Solutions from './pages/Solutions';
import Company from './pages/Company';
import Contact from './pages/Contact';
import RFQ from './pages/RFQ';
import Industries from './pages/Industries';
import OEMManufacturing from './pages/OEMManufacturing';
import Fabrication from './pages/Fabrication';
import PorcelainTiles from './pages/PorcelainTiles';
import GlobalSourcing from './pages/GlobalSourcing';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/oem-manufacturing" element={<OEMManufacturing />} />
        <Route path="/fabrication" element={<Fabrication />} />
        <Route path="/paper-machines" element={<PaperMachines />} />
        <Route path="/porcelain-tiles" element={<PorcelainTiles />} />
        <Route path="/global-sourcing" element={<GlobalSourcing />} />
        <Route path="/about" element={<Company />} />
        <Route path="/company" element={<Company />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/contact/rfq" element={<RFQ />} />
        <Route path="/industrial-machines" element={<IndustrialMachines />} />
        <Route path="/waste-paper" element={<GlobalSourcing />} />
        <Route path="/cat" element={<Categories />} />
        <Route path="/category/:id" element={<CategoryMachines />} />
        <Route path="/machine/:id" element={<MachineDetail />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
